<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main-message">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">リマインダー配信メッセージ一覧</div>
        </div>

        <a class="c-btn c-btn--blue u-w250" @click="onClickAddMessage">
          <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
          </div>
          <p class="c-btn__text">配信メッセージの作成</p>
        </a>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-search">
            <form @submit.prevent="onSearchIconClick($event)">
              <div class="p-message-search-keyword">
                <div class="c-checkbox reminder-search-status">
                  <div class="c-checkbox__title">配信状況</div>
                  <ul class="c-checkbox-list">
                    <li class="c-checkbox-list__item">
                      <label class="c-checkbox__label">
                        <input v-model="deliverFlags" type="checkbox" :value="1" />
                        <div class="c-checkbox__item">
                          <div class="c-checkbox__box"></div>
                          <div class="c-checkbox__box-label">配信中</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-checkbox-list__item">
                      <label class="c-checkbox__label">
                        <input v-model="deliverFlags" type="checkbox" :value="0" />
                        <div class="c-checkbox__item">
                          <div class="c-checkbox__box"></div>
                          <div class="c-checkbox__box-label">停止中</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="c-input">
                  <input
                    v-model="pushName"
                    class="c-input__item c-input__item--overlay-ico"
                    type="text"
                    placeholder="リマインダーID・タイトル・メッセージで検索"
                  />
                  <div class="c-input__icon c-input__icon--overlay" @click="onSearchIconClick($event)">
                    <div class="c-icon c-icon--white u-wh30">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#search" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div
            class="p-message-result__data"
            :class="{ 'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }"
          >
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信メッセージが存在しません</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable reminder-id-col">
                    <span class="c-table__text">リマインダーID</span>
                    <sort-switch name="label" :order="sortTargets.label" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center is-sortable reminder-message-col">
                    <span class="c-table__text">配信メッセージ</span>
                    <sort-switch name="title" :order="sortTargets.title" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center m-w90 u-w90">配信通数</th>
                  <th class="c-table__cell--center">配信条件</th>
                  <th class="c-table__cell--center m-w110 u-w110">配信時間帯</th>
                  <th class="c-table__cell--center m-w90 u-w90">配信状況</th>
                </tr>
              </thead>

              <reminder-message-list-item
                v-for="(message, index) in messages.data"
                :key="index"
                :message="message"
                :default-icon-url="messageInfo.defaultIconUrl"
                :operator-labels="messageInfo.operatorLabels"
                @delete-click="onDeleteMessage"
                @stop-click="onStopMessage"
                @start-click="onStartMessage"
                @edit-click="onEditMessage"
                @review-click="onReviewMessage"
              />
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refDeleteModal"
      classes="c-modal--message-delete"
      title="以下のメッセージを削除してもよろしいですか?"
      :body="`メッセージ : ${currentReminderLabel} / ${currentMessageTitle}`"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active="isDeleteMessage"
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCloseControlModal"
      :on-enter-click="onEnterDeleteModal"
    />

    <!-- モーダル: 停止確認 -->
    <control-modal
      ref="refStopModal"
      classes="c-modal--message-puse"
      title="以下のメッセージを停止してもよろしいですか?"
      :body="`メッセージ : ${currentReminderLabel} / ${currentMessageTitle}`"
      cancel-button-label="キャンセル"
      enter-button-label="停止する"
      :is-active="isStopMessage"
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCloseControlModal"
      :on-enter-click="onEnterStopModal"
    />

    <!-- モーダル: 配信開始確認 -->
    <control-modal
      ref="refStartModal"
      classes="c-modal--message-puse"
      title="以下のメッセージの配信を開始してもよろしいですか?"
      :body="`メッセージ : ${currentReminderLabel} / ${currentMessageTitle}`"
      cancel-button-label="キャンセル"
      enter-button-label="配信開始する"
      :is-active="isStartMessage"
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCloseControlModal"
      :on-enter-click="onEnterStartModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal :is-active="isError" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    messageInfo: Object,
  },
  data() {
    return {
      currentMessageId: null,
      currentReminderLabel: null,
      currentMessageTitle: null,
      messages: [],
      deliverFlags: [],
      pushName: null,
      sortTargets: {
        label: 0,
        title: 0,
      },
      paginationInfo: null,
      page: 1,

      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      isDeleteMessage: false,
      isStopMessage: false,
      isStartMessage: false,
      searchConditionCache: null,
    };
  },
  watch: {
    deliverFlags: function () {
      this.page = 1;
      this.loadData();
    },
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function (useCache) {
      useCache = useCache || false;

      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if (this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      let params = {
        params: {
          pushName: this.pushName,
          deliverFlags: this.deliverFlags,
          sort: sortTarget,
          order: order,
          page: this.page,
        },
      };

      if (useCache) {
        params = JSON.parse(JSON.stringify(this.searchConditionCache));
        params.params.page = this.page;
      } else {
        this.searchConditionCache = params;
      }

      this.isLoading = true;
      this.isLoaded = false;

      axios
        .get('/api/reminder/message/list', params)
        .then((res) => {
          this.messages = res.data.messages;
          this.paginationInfo = res.data.messages;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            this.isEmpty = res.data.messages.data.length < 1;
          }, 300);
        })
        .catch((error) => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = '配信メッセージ一覧の取得時にエラーが発生しました';
            this.isLoading = false;
          }, 300);
        });
    },

    onClickAddMessage: function () {
      location.href = this.messageInfo.addUrl;
    },

    onClickSearch: function () {
      this.page = 1;
      this.loadData();
    },

    onSearchIconClick: function (event) {
      event.preventDefault();
      this.page = 1;
      this.loadData();
    },

    onClickSortButton: function (target) {
      if (!this.sortTargets[target] || this.sortTargets[target] == -1) {
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if (workTarget != target) {
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    getDisplayTitle: function (message) {
      if (message.message_title) return message.message_title;
      var firstSchedule = (message.schedules || []).find(function (s) {
        return s.schedule_index === 0;
      });
      if (!firstSchedule && message.schedules && message.schedules.length > 0) firstSchedule = message.schedules[0];
      return firstSchedule ? firstSchedule.message_title : '';
    },

    onDeleteMessage: function (message) {
      this.currentMessageId = message.message_id;
      this.currentReminderLabel = message.reminder_id;
      this.currentMessageTitle = this.getDisplayTitle(message);
      this.isDeleteMessage = true;
    },

    onStopMessage: function (message) {
      this.currentMessageId = message.message_id;
      this.currentReminderLabel = message.reminder_id;
      this.currentMessageTitle = this.getDisplayTitle(message);
      this.isStopMessage = true;
    },

    onStartMessage: function (message) {
      this.currentMessageId = message.message_id;
      this.currentReminderLabel = message.reminder_id;
      this.currentMessageTitle = this.getDisplayTitle(message);
      this.isStartMessage = true;
    },

    onEditMessage: function (message) {
      location.href = this.messageInfo.addUrl + '?type=edit&message_id=' + message.message_id;
    },

    onReviewMessage: function (message) {
      location.href = '/coins-admin/reminder/message/add-condition-confirm?message_id=' + message.message_id;
    },

    onCloseErrorModal: function () {
      this.isError = false;
      this.errorMessage = '';
    },

    onCloseControlModal: function () {
      this.isDeleteMessage = false;
      this.isStopMessage = false;
      this.isStartMessage = false;
      if (this.$refs.refDeleteModal) this.$refs.refDeleteModal.resetErrorMessage();
      if (this.$refs.refStopModal) this.$refs.refStopModal.resetErrorMessage();
      if (this.$refs.refStartModal) this.$refs.refStartModal.resetErrorMessage();
    },

    onEnterDeleteModal: function () {
      this.$refs.refDeleteModal.showLoader();

      const params = {
        message_id: this.currentMessageId,
      };

      axios
        .post('/api/reminder/message/delete', params)
        .then((_res) => {
          this.$refs.refDeleteModal.hideLoader();
          this.isDeleteMessage = false;
          this.errorMessage = '';
          this.isLoading = true;
          this.loadData();
        })
        .catch((error) => {
          this.$refs.refDeleteModal.hideLoader();
          this.$refs.refDeleteModal.showErrorMessage('メッセージの削除に失敗しました');
          this.handleHttpError(error);
        });
    },

    onEnterStopModal: function () {
      this.$refs.refStopModal.showLoader();

      const params = {
        message_id: this.currentMessageId,
      };

      axios
        .post('/api/reminder/message/stop', params)
        .then((_res) => {
          this.$refs.refStopModal.hideLoader();
          this.isStopMessage = false;
          this.errorMessage = '';
          this.isLoading = true;
          this.loadData();
        })
        .catch((error) => {
          this.$refs.refStopModal.hideLoader();
          this.$refs.refStopModal.showErrorMessage('メッセージの停止に失敗しました');
          this.handleHttpError(error);
        });
    },

    onEnterStartModal: function () {
      this.$refs.refStartModal.showLoader();

      const params = {
        message_id: this.currentMessageId,
      };

      axios
        .post('/api/reminder/message/start', params)
        .then((_res) => {
          this.$refs.refStartModal.hideLoader();
          this.isStartMessage = false;
          this.errorMessage = '';
          this.isLoading = true;
          this.loadData();
        })
        .catch((error) => {
          this.$refs.refStartModal.hideLoader();
          this.$refs.refStartModal.showErrorMessage('メッセージの配信開始に失敗しました');
          this.handleHttpError(error);
        });
    },

    onPageClick: function (clickPage) {
      this.page = clickPage;
      this.loadData(true);
    },
  },
};
</script>

<style>
@media (min-width: 1500px) {
  .l-main-message {
    width: calc(100% - 280px) !important;
  }
}
.m-w90 {
  width: 90px !important;
  min-width: 90px !important;
}
.m-w110 {
  width: 110px !important;
  min-width: 110px !important;
}
.m-w120 {
  width: 120px !important;
  min-width: 120px !important;
}
/*
 * リマインダーID列: 固定幅を持たせず、最小幅のみ設定。
 * table-layout: auto により、IDが長いほど max-content が大きくなり、
 * 残余幅がこの列に優先的に分配されるため、内容に応じて自然に伸縮する。
 * 極端に長いIDは reminder-id-cell の word-break で折り返される。
 */
.reminder-id-col {
  min-width: 140px !important;
}
/*
 * 配信メッセージ列: ミニプレビューカード(最大280px)に合わせ概ね固定幅に。
 */
.reminder-message-col {
  width: 300px !important;
  min-width: 280px !important;
  max-width: 320px !important;
}
</style>

<style scoped>
.reminder-search-status {
  display: flex;
  align-items: center;
  gap: 16px;
}
.reminder-search-status .c-checkbox__title {
  margin: 0;
  padding-bottom: 0;
  white-space: nowrap;
  font-size: 13px;
}
.reminder-search-status .c-checkbox-list {
  display: flex;
  gap: 12px;
}
.reminder-search-status .c-checkbox-list__item {
  margin: 0;
}
</style>
